import React from 'react';
import AddBrandsComponent from '../../../Components/Brands/AddBrands';

export default function AddBrands() {
    return (
        <div className='page-body'>
            <AddBrandsComponent />
        </div>
    );
}